import { createFileRoute } from "@tanstack/react-router"
import { MembersInvitesPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/invites"
)({
  component: () => (
    <AuthorizationGate resource={Resource.INVITATION} action={Action.READ}>
      <MembersInvitesPage />
    </AuthorizationGate>
  ),
})
